import React, { useState, useEffect } from "react";
import { Menu, X, ShoppingBag } from "lucide-react";

const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "Products", id: "products" },
  { label: "About", id: "about" },
  { label: "Testimonials", id: "testimonials" },
  { label: "Contact", id: "contact" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMobileOpen(false);
  };

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 backdrop-blur-xl bg-white/85 border-b border-orange-100 ${
        scrolled ? "py-2 shadow-md" : "py-3"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
        {/* Logo */}
        <button
          onClick={() => scrollTo("home")}
          className="flex items-center"
          data-testid="navbar-logo"
        >
          <img src="/munhonnlogo.png" alt="MunchhONN Mood Banaye Mast" className="h-10 sm:h-12 object-contain" />
        </button>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-7">
          {NAV_LINKS.map(({ label, id }) => (
            <button
              key={id}
              onClick={() => scrollTo(id)}
              className="text-stone-600 font-medium text-sm hover:text-orange-500 transition-colors duration-200 relative group"
              data-testid={`nav-${id}`}
            >
              {label}
              <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-orange-500 group-hover:w-full transition-all duration-300 rounded-full" />
            </button>
          ))}
        </div>

        {/* CTA Button */}
        <button
          onClick={() => scrollTo("products")}
          className="hidden md:flex items-center gap-2 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-full px-5 py-2.5 font-bold text-sm shadow-lg hover:shadow-orange-500/30 hover:scale-105 transition-all duration-200"
          data-testid="navbar-explore-btn"
        >
          <ShoppingBag size={16} />
          Explore Products
        </button>

        {/* Hamburger */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden p-2 rounded-xl hover:bg-orange-50 transition-colors"
          data-testid="hamburger-btn"
        >
          {mobileOpen ? (
            <X size={24} className="text-stone-700" />
          ) : (
            <Menu size={24} className="text-stone-700" />
          )}
        </button>
      </div>

      {/* Mobile Drawer */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          mobileOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
        data-testid="mobile-drawer"
      >
        <div className="bg-white border-t border-orange-100 px-4 py-5 space-y-1">
          {NAV_LINKS.map(({ label, id }) => (
            <button
              key={id}
              onClick={() => scrollTo(id)}
              className="block w-full text-left px-3 py-3 text-stone-700 font-medium rounded-xl hover:bg-orange-50 hover:text-orange-600 transition-colors duration-200"
              data-testid={`mobile-nav-${id}`}
            >
              {label}
            </button>
          ))}
          <div className="pt-2">
            <button
              onClick={() => scrollTo("products")}
              className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-full py-3 font-bold shadow-md"
              data-testid="mobile-navbar-cta"
            >
              <ShoppingBag size={16} />
              Explore Products
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
